import { Directive, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAutoValidate]',
  standalone: true,
  host: {
    '[class.ng-dirty]':   'shouldShowError()',
    '[class.ng-invalid]': 'shouldShowError()'
  }
})
export class AutoValidateDirective {
  private control = inject(NgControl, { optional: true, self: true });

  shouldShowError(): boolean {
    const ctrl = this.control?.control;
    return !!(ctrl?.invalid && ctrl?.touched);
  }
}
